import React from 'react'

const Divider = () => {
  return (
    <svg width="100%" height="10"><line x1="0" y1="5" x2="100%" y2="5" stroke="var(--copperGlow)" strokeWidth="4" strokeDasharray="12, 10" strokeLinecap="round" /></svg>
  )
}

export default Divider
